import React, { type JSX } from "react";
import { CQAInvoice, WorkItemEnhanced } from "../../../types/cqa";
import checkCircle from "../../../../public/assets/icons/check-circle.svg";
import minusCircle from "../../../../public/assets/icons/minus-circle.svg";
import plusCircle from "../../../../public/assets/icons/plus-circle.svg";
import Grid from "@mui/material/Grid";
import { CQARiskDictionaries } from "../../../types/dictionary";

const ChangesGridTheme = { display: "flex", justifyContent: "center", alignItems: "center", gap: "4px", minWidth: '20px' };
const ChangesNumberTheme = {width: '15px', display: 'flex', justifyContent: 'right'};

interface Props {
    data: WorkItemEnhanced;
    riskDictionaries: CQARiskDictionaries | null;
}

function calculateChanges(cqaInvoice: CQAInvoice, riskDictionaries: CQARiskDictionaries) {
    let approved = 0, removed = 0, added = 0;

    cqaInvoice.transactions.forEach((transaction) => {
        transaction.procedures.forEach((procedure) => {
            if(!procedure.original){
                added += 1;
            }

            if(procedure.codeAssessment){
                const row = riskDictionaries.procedure.rowValues.find((row) => row.ASSESSMENT === procedure.codeAssessment.assessment);
                
                if(row && row.CATEGORY === "CORRECT") {
                    approved += 1;
                }
                else if(row && row.CATEGORY === "INCORRECT") {
                    removed -= 1;
                }
            }
        });

        transaction.diagnoses.forEach((diagnosis) => {
            if(!diagnosis.original){
                added += 1;
            }

            if(diagnosis.codeAssessment){
                const row = riskDictionaries.diagnosis.rowValues.find((row) => row.ASSESSMENT === diagnosis.codeAssessment.assessment);

                if(row && row.CATEGORY === "CORRECT") {
                    approved += 1;
                }
                else if(row && row.CATEGORY === "INCORRECT") {
                    removed -= 1;
                }
            }
        });

        transaction.modifiers.forEach((modifier) => {
            if(!modifier.original){
                added += 1;
            }

            if(modifier.codeAssessment){
                const row = riskDictionaries.modifier.rowValues.find((row) => row.ASSESSMENT === modifier.codeAssessment.assessment);
                
                if(row && row.CATEGORY === "CORRECT") {
                    approved += 1;
                }
                else if(row && row.CATEGORY === "INCORRECT") {
                    removed -= 1;
                }
            }
        });
    });

    return { approved, removed, added };
}

export function CQAChangesRow({ data, riskDictionaries }: Props): JSX.Element {
    const cqaInvoices = data.cqa_invoices;

    if(!cqaInvoices || cqaInvoices.length === 0 || !riskDictionaries){
        return null;
    }

    const changes = calculateChanges(cqaInvoices[0], riskDictionaries);

    return (
        <Grid container spacing={1}>
            <Grid item sx={ChangesGridTheme}>
                <Grid item sx={ChangesNumberTheme}>
                    <span>{changes.approved}</span>
                </Grid>
                <Grid item>
                    <img src={checkCircle} alt="approved" />
                </Grid>
            </Grid>
            <Grid item sx={ChangesGridTheme}>
                <Grid item sx={ChangesNumberTheme}>
                    <span>{`${changes.removed}`}</span>
                </Grid>
                <Grid item>
                    <img src={minusCircle} alt="removed" />
                </Grid>
            </Grid>
            <Grid item sx={ChangesGridTheme}>
                <Grid item sx={ChangesNumberTheme}>
                    <span>{`${changes.added > 0 ? '+' : ''}${changes.added}`}</span>
                </Grid>
                <Grid item>
                    <img src={plusCircle} alt="added"/>
                </Grid>
            </Grid>
        </Grid>
    )
}